// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1204":"css/app.7002","1215":"css/admin-app.7002"}[chunkId] + ".css";
};